import { Action, TreatmentDatesState } from './types'
import { getDefaultTreatmentDates } from './AppStateDefaults'

// Accepts a partial payload: the reducer merges it into the current state, so a
// screen must only send the fields it actually intends to change. Sending a full
// snapshot (`{...complaint.treatmentDates, ...}`) resurrects stale values and undoes
// other dispatches batched in the same handler.
export const setTreatmentDates = (treatmentDates: Partial<TreatmentDatesState>) => ({
    type: 'SET_TREATMENT_DATES',
    payload: {
        ...treatmentDates,
    },
})

// In the case that the user returns to the Product Type screen
// and changes their answer from Yes to No, then reset the values
// of certain fields found on the Treatment Dates screen
export const resetTreatmentDates = () => {
    const defaults = getDefaultTreatmentDates()

    return {
        type: 'RESET_TREATMENT_DATES',
        payload: {
            dateOfTreatment: defaults.dateOfTreatment,
            wasImplantLoaded: defaults.wasImplantLoaded,
            dateOfImplantLoading: defaults.dateOfImplantLoading,
            wasThereASecondSurgery: defaults.wasThereASecondSurgery,
            dateOfSecondSurgery: defaults.dateOfSecondSurgery,
            wasProductRemoved: defaults.wasProductRemoved,
            dateProductWasRemoved: defaults.dateProductWasRemoved,
        },
    }
}

const treatmentDatesReducer: React.Reducer<TreatmentDatesState, Action> = (
    state: TreatmentDatesState,
    action: Action
) => {
    switch (action.type) {
        case 'SET_TREATMENT_DATES':
            return {
                ...state,
                ...action.payload,
            }

        case 'RESET_TREATMENT_DATES':
            return {
                ...state,
                ...action.payload,
            }

        default:
            return state
    }
}

export default treatmentDatesReducer
